import authHeader from "@/services/auth/AuthHeader";
import axios from "axios";

/**
 * Service for refunding orders paid entirely with bonus points.
 * No payment provider is involved — bonus points are returned to the customer's loyalty account.
 * For mixed orders (bonus + payment provider), the payment provider services handle the bonus
 * portion via the refundedBonusAmount parameter instead.
 */
class BonusRefundService {
    refund(amount, cartItems, refundedTipsAmount, orderDocumentId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/payment/bonusRefund';
        let basicAuth = authHeader();
        return axios.post(url,
            {
                merchant: user.merchant,
                amount: amount,
                cartItems: cartItems,
                refundedTipsAmount: refundedTipsAmount,
                orderDocumentId: orderDocumentId
            },
            {headers: basicAuth });
    }
}

export default new BonusRefundService();
